import AccountIconRaw from '../assets/icons/db_ic_account_32.svg?react'
import AddCircleIconRaw from '../assets/icons/db_ic_add_circle_24.svg?react'
import AlertIconIconRaw from '../assets/icons/db_ic_alert_32.svg?react'
import ArrowBackIconRaw from '../assets/icons/db_ic_arrow_back_32.svg?react'
import ArrowForwardIconRaw from '../assets/icons/db_ic_arrow_forward_20.svg?react'
import ArrowUpIconRaw from '../assets/icons/db_ic_arrow_up_24.svg?react'
import BlockIconRaw from '../assets/icons/db_ic_block_24.svg?react'
import BrowserNotificationsIconRaw from '../assets/icons/app_ic_browser_notifications_32.svg?react'
import BuildIconRaw from '../assets/icons/db_ic_build_32.svg?react'
import CalendarIconRaw from '../assets/icons/db_ic_calendar_20.svg?react'
import CancelIconRaw from '../assets/icons/db_ic_cancel_24.svg?react'
import ChatIcon24Raw from '../assets/icons/db_ic_chat_24.svg?react'
import ChatIcon32Raw from '../assets/icons/db_ic_chat_32.svg?react'
import ChatNewIconRaw from '../assets/icons/app_ic_chat_new_24.svg?react'
import CheckCircleIcon24Raw from '../assets/icons/db_ic_check_circle_24.svg?react'
import CheckCircleIcon32Raw from '../assets/icons/db_ic_check_circle_32.svg?react'
import ChevronRightIcon20Raw from '../assets/icons/db_ic_chevron_right_20.svg?react'
import ChevronRightIcon24Raw from '../assets/icons/db_ic_chevron_right_24.svg?react'
import ChevronRightIcon32Raw from '../assets/icons/db_ic_chevron_right_32.svg?react'
import ChevronLeftIcon20Raw from '../assets/icons/db_ic_chevron_left_20.svg?react'
import ChevronLeftIcon24Raw from '../assets/icons/db_ic_chevron_left_24.svg?react'
import CloseIconRaw24 from '../assets/icons/db_ic_close_24.svg?react'
import CloseIconRaw32 from '../assets/icons/db_ic_close_32.svg?react'
import DeleteIconRaw from '../assets/icons/db_ic_delete_24.svg?react'
import DayIconRaw from '../assets/icons/db_ic_day_24.svg?react'
import DocumentIconRaw from '../assets/icons/db_ic_document_32.svg?react'
import DocumentNewIconRaw from '../assets/icons/app_ic_document_new_24.svg?react'
import DoneIcon24Raw from '../assets/icons/db_ic_done_24.svg?react'
import DoneIcon32Raw from '../assets/icons/db_ic_done_32.svg?react'
import DownloadIconRaw from '../assets/icons/db_ic_download_24.svg?react'
import DragAndDropIconRaw from '../assets/icons/db_ic_drag_and_drop_24.svg?react'
import EditIconRaw from '../assets/icons/db_ic_edit_24.svg?react'
import ErrorIconRaw from '../assets/icons/db_ic_error_32.svg?react'
import ExpandMoreIcon20Raw from '../assets/icons/db_ic_expand_more_20.svg?react'
import ExpandMoreIcon32Raw from '../assets/icons/db_ic_expand_more_32.svg?react'
import FilterIcon20Raw from '../assets/icons/db_ic_filter_20.svg?react'
import FilterIcon24Raw from '../assets/icons/db_ic_filter_24.svg?react'
import FolderOpenIconRaw from '../assets/icons/db_ic_folder_open_32.svg?react'
import InfoIconRaw from '../assets/icons/db_ic_info_24.svg?react'
import LogOutIconRaw from '../assets/icons/db_ic_log_out_24.svg?react'
import MailIcon24Raw from '../assets/icons/db_ic_mail_24.svg?react'
import MailIcon32Raw from '../assets/icons/db_ic_mail_32.svg?react'
import MarkRedrawnIconRaw from '../assets/icons/app_ic_mark_redrawn_24.svg?react'
import MenuIconRaw from '../assets/icons/db_ic_menu_32.svg?react'
import NightIconRaw from '../assets/icons/db_ic_night_24.svg?react'
import NotifyIconRaw from '../assets/icons/db_ic_notify_32.svg?react'
import PlaceIconRaw from '../assets/icons/db_ic_place_24.svg?react'
import ScheduleIconRaw from '../assets/icons/db_ic_schedule_20.svg?react'
import SearchIconRaw from '../assets/icons/db_ic_search_32.svg?react'
import ScreenIconRaw from '../assets/icons/app_ic_screen_32.svg?react'
import SendBfnIconRaw from '../assets/icons/app_ic_send_bfn_24.svg?react'
import UndoIconRaw from '../assets/icons/db_ic_undo_24.svg?react'
import VisibilityIconRaw from '../assets/icons/db_ic_visibility_24.svg?react'
import WarningIcon20Raw from '../assets/icons/db_ic_warning_20.svg?react'
import WarningIcon24Raw from '../assets/icons/db_ic_warning_24.svg?react'
import WifiOffIconRaw from '../assets/icons/db_ic_wifi_off_32.svg?react'
import DbLogoIconRaw from '../assets/icons/db_logo.svg?react'
import LocalTrainIcon32Raw from '../assets/icons/db_ic_local_train_32.svg?react'

// Befehle
import Befehl1IconRaw from '../assets/icons/befehle/app_ic_befehl_01.svg?react'
import Befehl2IconRaw from '../assets/icons/befehle/app_ic_befehl_02.svg?react'
import Befehl3IconRaw from '../assets/icons/befehle/app_ic_befehl_03.svg?react'
import Befehl4IconRaw from '../assets/icons/befehle/app_ic_befehl_04.svg?react'
import Befehl5IconRaw from '../assets/icons/befehle/app_ic_befehl_05.svg?react'
import Befehl6IconRaw from '../assets/icons/befehle/app_ic_befehl_06.svg?react'
import Befehl7IconRaw from '../assets/icons/befehle/app_ic_befehl_07.svg?react'
import Befehl8IconRaw from '../assets/icons/befehle/app_ic_befehl_08.svg?react'
import Befehl9IconRaw from '../assets/icons/befehle/app_ic_befehl_09.svg?react'
import Befehl21IconRaw from '../assets/icons/befehle/app_ic_befehl_21.svg?react'
import Befehl22IconRaw from '../assets/icons/befehle/app_ic_befehl_22.svg?react'
import Befehl23IconRaw from '../assets/icons/befehle/app_ic_befehl_23.svg?react'
import Befehl24IconRaw from '../assets/icons/befehle/app_ic_befehl_24.svg?react'
import Befehl25IconRaw from '../assets/icons/befehle/app_ic_befehl_25.svg?react'
import Befehl26IconRaw from '../assets/icons/befehle/app_ic_befehl_26.svg?react'
import Befehl27IconRaw from '../assets/icons/befehle/app_ic_befehl_27.svg?react'
import Befehl28IconRaw from '../assets/icons/befehle/app_ic_befehl_28.svg?react'
import Befehl29IconRaw from '../assets/icons/befehle/app_ic_befehl_29.svg?react'
import Befehl30IconRaw from '../assets/icons/befehle/app_ic_befehl_30.svg?react'
import Befehl31IconRaw from '../assets/icons/befehle/app_ic_befehl_31.svg?react'
import Befehl32IconRaw from '../assets/icons/befehle/app_ic_befehl_32.svg?react'
import Befehl33IconRaw from '../assets/icons/befehle/app_ic_befehl_33.svg?react'
import Befehl34IconRaw from '../assets/icons/befehle/app_ic_befehl_34.svg?react'
import Befehl95IconRaw from '../assets/icons/befehle/app_ic_befehl_95.svg?react'

import { withDefaultIconProps } from './withDefaultIconProps'

export const AccountIcon32 = withDefaultIconProps(AccountIconRaw, 32)
export const AddCircleIcon24 = withDefaultIconProps(AddCircleIconRaw, 24)
export const AlertIcon32 = withDefaultIconProps(AlertIconIconRaw, 32)
export const ArrowBackIcon32 = withDefaultIconProps(ArrowBackIconRaw, 32)
export const ArrowForwardIcon20 = withDefaultIconProps(ArrowForwardIconRaw, 20)
export const ArrowUpIcon24 = withDefaultIconProps(ArrowUpIconRaw, 24)
export const BlockIcon24 = withDefaultIconProps(BlockIconRaw, 24)
export const BrowserNotificationsIcon32 = withDefaultIconProps(
  BrowserNotificationsIconRaw,
  32
)
export const BuildIcon32 = withDefaultIconProps(BuildIconRaw, 32)
export const CalendarIcon20 = withDefaultIconProps(CalendarIconRaw, 20)
export const CancelIcon24 = withDefaultIconProps(CancelIconRaw, 24)
export const ChatNewIcon24 = withDefaultIconProps(ChatNewIconRaw, 24)
// noinspection JSUnusedGlobalSymbols
export const ChatIcon24 = withDefaultIconProps(ChatIcon24Raw, 24)
export const ChatIcon32 = withDefaultIconProps(ChatIcon32Raw, 32)
export const CheckCircleIcon24 = withDefaultIconProps(CheckCircleIcon24Raw, 24)
export const CheckCircleIcon32 = withDefaultIconProps(CheckCircleIcon32Raw, 32)
export const ChevronLeftIcon20 = withDefaultIconProps(ChevronLeftIcon20Raw, 20)
export const ChevronLeftIcon24 = withDefaultIconProps(ChevronLeftIcon24Raw, 24)
export const ChevronRightIcon20 = withDefaultIconProps(
  ChevronRightIcon20Raw,
  20
)
// noinspection JSUnusedGlobalSymbols
export const ChevronRightIcon24 = withDefaultIconProps(
  ChevronRightIcon24Raw,
  24
)
// noinspection JSUnusedGlobalSymbols
export const ChevronRightIcon32 = withDefaultIconProps(
  ChevronRightIcon32Raw,
  32
)
export const CloseIcon24 = withDefaultIconProps(CloseIconRaw24, 24)
export const CloseIcon32 = withDefaultIconProps(CloseIconRaw32, 32)
export const CloseIcon32ScaledTo16 = withDefaultIconProps(CloseIconRaw32, 16)
export const DayIcon24 = withDefaultIconProps(DayIconRaw, 24)
export const DeleteIcon24 = withDefaultIconProps(DeleteIconRaw, 24)
export const DocumentIcon32 = withDefaultIconProps(DocumentIconRaw, 32)
export const DocumentNewIcon24 = withDefaultIconProps(DocumentNewIconRaw, 24)
export const DoneIcon24 = withDefaultIconProps(DoneIcon24Raw, 24)
export const DoneIcon32 = withDefaultIconProps(DoneIcon32Raw, 32)
export const DownloadIcon24 = withDefaultIconProps(DownloadIconRaw, 24)
export const DragAndDropIcon24 = withDefaultIconProps(DragAndDropIconRaw, 24)
export const EditIcon24 = withDefaultIconProps(EditIconRaw, 24)
export const ErrorIcon32 = withDefaultIconProps(ErrorIconRaw, 32)
export const ExpandMoreIcon20 = withDefaultIconProps(ExpandMoreIcon20Raw, 20)
export const ExpandMoreIcon32 = withDefaultIconProps(ExpandMoreIcon32Raw, 32)
export const FilterIcon20 = withDefaultIconProps(FilterIcon20Raw, 20)
export const FilterIcon24 = withDefaultIconProps(FilterIcon24Raw, 24)
// noinspection JSUnusedGlobalSymbols
export const FolderOpenIcon32 = withDefaultIconProps(FolderOpenIconRaw, 32)
export const InfoIcon24 = withDefaultIconProps(InfoIconRaw, 24)
export const LogOutIcon24 = withDefaultIconProps(LogOutIconRaw, 24)
// noinspection JSUnusedGlobalSymbols
export const MailIcon24 = withDefaultIconProps(MailIcon24Raw, 24)
export const MailIcon32 = withDefaultIconProps(MailIcon32Raw, 32)
export const MarkRedrawnIcon24 = withDefaultIconProps(MarkRedrawnIconRaw, 24)
export const MenuIcon32 = withDefaultIconProps(MenuIconRaw, 32)
export const NightIcon24 = withDefaultIconProps(NightIconRaw, 24)
export const NotifyIcon32 = withDefaultIconProps(NotifyIconRaw, 32)
export const PlaceIcon24 = withDefaultIconProps(PlaceIconRaw, 24)
export const ScheduleIcon20 = withDefaultIconProps(ScheduleIconRaw, 20)
export const SearchIcon32 = withDefaultIconProps(SearchIconRaw, 32)
export const ScreenIcon32 = withDefaultIconProps(ScreenIconRaw, 32)
export const SendBfnIcon24 = withDefaultIconProps(SendBfnIconRaw, 24)
export const UndoIcon24 = withDefaultIconProps(UndoIconRaw, 24)
export const VisibilityIcon24 = withDefaultIconProps(VisibilityIconRaw, 24)
export const WarningIcon20 = withDefaultIconProps(WarningIcon20Raw, 20)
export const WarningIcon24 = withDefaultIconProps(WarningIcon24Raw, 24)
// noinspection JSUnusedGlobalSymbols
export const WifiOffIcon32 = withDefaultIconProps(WifiOffIconRaw, 32)
// noinspection JSUnusedGlobalSymbols
export const DbLogoIcon = withDefaultIconProps(DbLogoIconRaw, 40)
export const LocalTrainIcon32 = withDefaultIconProps(LocalTrainIcon32Raw, 32)
// Befehle
export const Befehl1Icon = withDefaultIconProps(Befehl1IconRaw, 64)
export const Befehl2Icon = withDefaultIconProps(Befehl2IconRaw, 64)
export const Befehl3Icon = withDefaultIconProps(Befehl3IconRaw, 64)
export const Befehl4Icon = withDefaultIconProps(Befehl4IconRaw, 64)
export const Befehl5Icon = withDefaultIconProps(Befehl5IconRaw, 64)
export const Befehl6Icon = withDefaultIconProps(Befehl6IconRaw, 64)
export const Befehl7Icon = withDefaultIconProps(Befehl7IconRaw, 64)
export const Befehl8Icon = withDefaultIconProps(Befehl8IconRaw, 64)
export const Befehl9Icon = withDefaultIconProps(Befehl9IconRaw, 64)
export const Befehl21Icon = withDefaultIconProps(Befehl21IconRaw, 64)
export const Befehl22Icon = withDefaultIconProps(Befehl22IconRaw, 64)
export const Befehl23Icon = withDefaultIconProps(Befehl23IconRaw, 64)
export const Befehl24Icon = withDefaultIconProps(Befehl24IconRaw, 64)
export const Befehl25Icon = withDefaultIconProps(Befehl25IconRaw, 64)
export const Befehl26Icon = withDefaultIconProps(Befehl26IconRaw, 64)
export const Befehl27Icon = withDefaultIconProps(Befehl27IconRaw, 64)
export const Befehl28Icon = withDefaultIconProps(Befehl28IconRaw, 64)
export const Befehl29Icon = withDefaultIconProps(Befehl29IconRaw, 64)
export const Befehl30Icon = withDefaultIconProps(Befehl30IconRaw, 64)
export const Befehl31Icon = withDefaultIconProps(Befehl31IconRaw, 64)
export const Befehl32Icon = withDefaultIconProps(Befehl32IconRaw, 64)
export const Befehl33Icon = withDefaultIconProps(Befehl33IconRaw, 64)
export const Befehl34Icon = withDefaultIconProps(Befehl34IconRaw, 64)
export const Befehl95Icon = withDefaultIconProps(Befehl95IconRaw, 64)

export { useBefehlIcon } from './befehle'
